import router from "@/router";
import store from "@/store";
import storage from 'store'
import jwt_decode from "jwt-decode";
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { asyncPersonRouterMap, asyncCompanyRouterMap } from '@/router/router.config'

/**
 * 通过用户类型增加动态路由
 */
export function addAsyncRoutes() {
    
    if (storage.get(ACCESS_TOKEN)) {
        //解析token
        const decode = jwt_decode(storage.get(ACCESS_TOKEN));
        const accountType = decode.accountType
        const accountId = decode.accountId
        const userName = decode.userName
        store.commit('SET_ACCOUNT_TYPE', accountType)
        store.commit('SET_ACCOUNT_ID', accountId)
        store.commit('SET_USER_NAME', userName)
        if (accountType === 5) {
            router.addRoutes(asyncPersonRouterMap)
        } else if (accountType === 13) {
            // todo
            //增加主账号的masterAccountId
            router.addRoutes(asyncCompanyRouterMap)
        }
    }
}

// 递归提取所有路由的名称
export function getConstantRouterNames(routes, result = []) {
  routes.forEach(route => {
    if (route.name) {
      result.push(route.name)
    }
    if (route.children && route.children.length > 0) {
      getConstantRouterNames(route.children, result)
    }
  })
  return result
}